<template lang="html">
  <span v-if="deviceMd">
    <router-link to="/compare" event=""
      @click.native.prevent="checkFloorplanList()"
      tag="button" class="btn-compare btn btn-favourite px-4 py-2">
      Compare
    </router-link>
  </span>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import { create } from 'vue-modal-dialogs';
import BasicDialog from '@/components/Dialogs/BasicDialog';

const dialog = create(BasicDialog, 'content');

export default {
  name: 'compare-button',
  props: {
    floorplanId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      showFavourites: state => state.floorplans.showFavourites,
    }),
    ...mapGetters({
      filteredFloorplanList: 'floorplans/filteredFloorplanList',
      deviceMd: 'ui/deviceMd'
    }),
    activeFloorplansCount() {
      return (this.favouritesMode) ?
        this.favourites.length : this.activeFloorplans.length;
    }
  },
  methods: {
    ...mapMutations({
      setLeftFloorplanId: 'floorplans/compare/setLeftFloorplanId',
      setRightFloorplanId: 'floorplans/compare/setRightFloorplanId'
    }),
    checkFloorplanList() {
      if (this.filteredFloorplanList.length >= 2) {
        if (this.floorplanId) {
          this.setLeftFloorplanId(this.floorplanId);
        } else {
          this.setLeftFloorplanId('');
        }
        this.setRightFloorplanId('');
        this.$router.push('/compare');
      } else {
        let dialogText = 'Please have more than one floorplan filtered.';
        if (this.showFavourites) {
          dialogText = 'Please have more than one floorplan favourited.';
        }
        dialog(dialogText);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-compare {
  font-family: Scandia-Regular, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/CompareButton.vue